import { useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';

import { makeStyles  } from '@material-ui/core/styles';
import {
    Dialog,
    DialogContent,
    Button,
    Typography,
    Grid
} from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';

import { FormatoImpresionComprobante } from './FormatoImpresionComprobante';
import { useDispatch } from 'react-redux';
import { getUsuarioLiquidacionMesa, setUsuarioLiquidaciones } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { DESTINOS_COMPROBANTE } from '../../../utils/constants';
import { FormatoImpresionComprobanteDocumento } from './FormatoImpresionComprobanteDocumento';

const useStyles = makeStyles((theme) => ({
    background: {
        backgroundColor: theme.palette.grey[50]
    }
}));

export const ImpresionComprobante = ({comprobante, titulo, documento, ospeDirecto}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [open, setOpen] = useState(false);

    const produccion = process.env.REACT_APP_ENVIRONMENT === 'production'; 

    const handleClose = () => {
        if(!documento && comprobante.idDestino === DESTINOS_COMPROBANTE.LIQUIDACIONES && produccion){
            dispatch(setUsuarioLiquidaciones(""));
            setOpen(false);
        }
        setOpen(false);
    };

    const handleClickOpen = () => {
        if(!documento && comprobante.idDestino === DESTINOS_COMPROBANTE.LIQUIDACIONES && produccion){
            dispatch(getUsuarioLiquidacionMesa({setOpen, idEfectorFacturacion: comprobante?.idEfectorFacturacion}));
        }else{
            setOpen(true);
        }
    };

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const handlePrintRow = () => {
        handlePrint();
        setOpen(false);
    }
    
    return (
        <>
            {titulo ? 
                (<>
                    <Grid item xs={12} style={{textAlign: "center", margin: ".5em"}}>
                        <Typography variant='h5'>
                            Desea Imprimir Comprobante?
                        </Typography>
                    </Grid>
                    <Grid item xs={12} style={{textAlign: "center", margin: ".5em"}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleClickOpen}
                        >
                            IMPRIMIR COMPROBANTE
                        </Button>
                    </Grid>
                </>
                )
                :
                (<Button
                    onClick={handleClickOpen}
                >
                    <PrintIcon fontSize="large" />
                </Button>)
            }
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth='lg'
            >
                <DialogContent className={classes.background}>
                    {documento ? (
                        <FormatoImpresionComprobanteDocumento 
                            comprobante={comprobante}
                            handleClose={handleClose}
                            handlePrintRow={handlePrintRow}
                            componentRef={componentRef}
                            modal
                        />
                    ) : (
                        <FormatoImpresionComprobante 
                            comprobante={comprobante}
                            handleClose={handleClose}
                            handlePrintRow={handlePrintRow}
                            componentRef={componentRef}
                            modal
                            ospeDirecto={ospeDirecto}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}